import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import ListingDetailPage from "./pages/ListingDetailPage";
import CreateListingPage from "./pages/CreateListingPage";
import CompleteProfilePage from "./pages/CompleteProfilePage";
import UserProfilePage from "./pages/UserProfilePage";
import CartPage from "./pages/CartPage";
import OrdersPage from "./pages/OrdersPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import CreateVideoPage from "./pages/CreateVideoPage";
import EditListingPage from "./pages/EditListingPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import FaqPage from "./pages/FaqPage";
import AuthCallback from "./pages/AuthCallback";
import InboxPage from "./pages/InboxPage";
import ChatPage from "./pages/ChatPage";
import WishlistPage from "./pages/WishlistPage";
import PaymentRedirect from "./pages/PaymentRedirect";
import QrisCheckout from "./pages/QrisCheckout";
import SessionExpiredPage from "./pages/SessionExpiredPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  const { user, loading } = useAuth();
  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  // Guard: logged-in users without completed profile are forced to /complete-profile
  if (!loading && user && !user.profile_completed && location.pathname !== '/complete-profile') {
    return <Navigate to="/complete-profile" replace />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/listing/:id" element={<ListingDetailPage />} />
      <Route path="/listing/:id/edit" element={<EditListingPage />} />
      <Route path="/sell" element={<CreateListingPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/post-video" element={<CreateVideoPage />} />
      <Route path="/complete-profile" element={<CompleteProfilePage />} />
      <Route path="/profile/:userId" element={<UserProfilePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/messages" element={<InboxPage />} />
      <Route path="/messages/:conversationId" element={<ChatPage />} />
      <Route path="/payment/redirect" element={<PaymentRedirect />} />
      <Route path="/payment/qris" element={<QrisCheckout />} />
      <Route path="/session-expired" element={<SessionExpiredPage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
